import * as React from "react"
import { connect } from "react-redux"
import { AxiosResponse } from "axios"
import trans from "trans"

import { ItemInterface, ReactSortable } from "react-sortablejs"

import {
    saveCollageLayout,
} from "app/helpers/api";

import {
    css,
    Grid,
    GridCell,
    FieldLabel,
    Div,
    Theme,
    Spinner,
    TextInput,
    Select,
    Range,
    InputGroup,
    Icon,
    Button,
} from "@bdfx/mergado-ui-kit"

import { Option } from "@bdfx/mergado-ui-kit/lib/components/Form/Select"

import { AlternativeTemplate, CollageImageShapes, CollageLayoutImageType, CollageLayoutType, Size, Template } from 'app/types/model-types';

import {
    updateInputValue as change,
    initForm
} from "app/reducers/form";

import { setGuides } from "actions"
import AlternativeImageSvg from "shape-entities/components/alternative-image-svg";
import { RandomProduct } from "shape-edit/types";
import { GuidesType, ID, ReduxList } from "app/types/app-types";
import CollageLayoutsImages, { MAX_ALTERNATIVE_IMAGES } from "./collage-layouts-images";
import { SizeItem } from "./sizes-settings";

import { iconDisabledColor } from "template-edit/components/tools-panel";
import { DELETE_KEY, ESCAPE_KEY, INSERT_KEY } from "app/helpers/keymap";
import { ClipMaskObject, ClipMaskObjectType, EmptyClipMaskObject } from "shape-edit/forms/edit-clip-mask-modal"
import { renderClipMaskShape } from "template-edit/components/helper"
import { CoordsType } from "shape-entities/components/shape"
import { isJson } from "app/helpers/other"
import { PathPoint } from "shape-entities/types/PathShape"
import TransparentColor from "shape-edit/forms/transparent-color"
import { selectFormValues } from "app/reducers/form"
import { IconGrid } from "app/icons"
import { getFormName, getGridStepSize, getTemplateSize, GRID_MODES_COUNT } from "shape-edit/forms/helpers"
import unique_id from "app/helpers/unique_id"
import { find, omitBy } from "lodash"
import { TemplateOrAlternativeTemplateType } from "template-edit/undoRedoReducers"

interface Props {
    id: number
    collageLayoutsForm: CollageLayoutType[]
    closeModal: Function
    randomProduct: RandomProduct
    sizes: ReduxList<SizeItem>
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    guides: GuidesType
    change: typeof change
    initForm: typeof initForm
    setGuides: typeof setGuides,
}

interface State {
    isLoaded: boolean
    isLoading: boolean
    isSaving: boolean
    isCreating: boolean
    selectedCollageId: ID
    selectedImageId: ID
    backgroundColor: string
    showAutocomplete: boolean
    autocompleteFor: string
    selectedSizeFormat: Size
    history: CollageLayoutsFormHistory
    isRelativeUnits: boolean
    copyImage: CollageLayoutImageType
    dx_rel: number
    dy_rel: number
    dw_rel: number
    dh_rel: number
}

type D = {
    dx_rel?: number
    dy_rel?: number
    dw_rel?: number
    dh_rel?: number
}

const MAX_BUFFER_SIZE = 5

type CollageLayoutsFormHistory = {
    initial: CollageLayoutType[]
    buffer: CollageLayoutType[]
    index: number
}

const initHistory: CollageLayoutsFormHistory = {
    initial: null,
    buffer: [],
    index: -1,
}

class CollageLayouts extends React.Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            isLoaded: false,
            isLoading: false,
            isSaving: false,
            isCreating: false,
            selectedCollageId: props.id,
            backgroundColor: 'transparent',
            selectedImageId: null,
            showAutocomplete: false,
            autocompleteFor: null,
            selectedSizeFormat: props.form?.size || { width: 1080, height: 1080 },
            history: initHistory,
            isRelativeUnits: false,
            copyImage: null,
            dx_rel: 0,
            dy_rel: 0,
            dw_rel: 0,
            dh_rel: 0
        }
    }

    handleChangePreviewSize = (sizeId: number) => {
        const { sizes } = this.props

        const selectedSizeFormat = sizes?.data ? find(sizes.data, (size: SizeItem) => {
            return `${size.id}` === `${sizeId}`
        }) : null

        if (selectedSizeFormat) {
            this.setState({ selectedSizeFormat: selectedSizeFormat })
        }
    }

    nextIndex = (index: number): number => {
        return (index + 1) % MAX_BUFFER_SIZE
    }

    prevIndex = (index: number): number => {
        return (MAX_BUFFER_SIZE + index - 1) % MAX_BUFFER_SIZE
    }

    undoHistory = () => {
        const { history } = this.state
        const newIndex = this.prevIndex(history.index)
        if (history.buffer[newIndex]) {
            this.props.initForm('collageLayoutsForm', history.buffer[newIndex])
            this.setState({ history: { ...history, index: newIndex } })
        }
    }

    redoHistory = () => {
        const { history } = this.state
        const newIndex = this.nextIndex(history.index)
        if (history.buffer[newIndex]) {
            this.props.initForm('collageLayoutsForm', history.buffer[newIndex])
            this.setState({ history: { ...history, index: newIndex } })
        }
    }

    pushHistory = () => {
        const { history } = this.state
        const { collageLayoutsForm } = this.props

        const newIndex = this.nextIndex(history.index)

        let newBuffer = []
        if (history.buffer.length) {
            newBuffer = [...history.buffer]
        }

        newBuffer[newIndex] = collageLayoutsForm

        if (typeof newBuffer[this.nextIndex(newIndex)] !== 'undefined') {
            newBuffer[this.nextIndex(newIndex)] = null  //clear next index
        }

        const updatedHistory : CollageLayoutsFormHistory = {
            ...history,
            initial: history.initial ? history.initial : collageLayoutsForm,
            buffer: newBuffer,
            index: newIndex
        }

        this.setState({ history: updatedHistory })
    }

    handleClickOnTextInput = (e, name) => {
        const { showAutocomplete } = this.state
        e.target.select()
        //this.setState({showAutocomplete: !showAutocomplete, autocompleteFor: name})
        this.setState({ autocompleteFor: name })
    }

    handleShowAutocomplete = (name) => {
        const { showAutocomplete } = this.state
        this.setState({ showAutocomplete: !showAutocomplete, autocompleteFor: name })
    }

    handleClickItem = (value, name) => {
        const { selectedCollageId, selectedImageId } = this.state
        this.props.change('collageLayoutsForm', `${selectedCollageId}.images.${selectedImageId}.${name}`, value)
        this.setState({ showAutocomplete: false, autocompleteFor: null })
    }

    handleChangeValue = (value, name) => {
        const { selectedCollageId, selectedImageId, isRelativeUnits, selectedSizeFormat } = this.state
        const newValue = isRelativeUnits ? value : (
            (name.includes('x') || name.includes('width')) ? value / selectedSizeFormat.width : value / selectedSizeFormat.height
        )
        this.setState({ showAutocomplete: false })
        this.props.change('collageLayoutsForm', `${selectedCollageId}.images.${selectedImageId}.${name}`, newValue)
    }

    displayValue = (value, valueType: 'x' | 'y'): number => {
        const { isRelativeUnits, selectedSizeFormat } = this.state
        return isRelativeUnits ?
            value :
            (valueType === 'x' ? Math.round(value * selectedSizeFormat.width) : Math.round(value * selectedSizeFormat.height))
    }

    setSelectedImageId = (imageId: ID) => {
        this.setState({ selectedImageId: imageId })
    }

    setD = (d: D) => {
        this.setState({
            dx_rel: typeof d?.dx_rel !== 'undefined' ? d.dx_rel : this.state.dx_rel,
            dy_rel: typeof d?.dy_rel !== 'undefined' ? d.dy_rel : this.state.dy_rel,
            dw_rel: typeof d?.dw_rel !== 'undefined' ? d.dw_rel : this.state.dw_rel,
            dh_rel: typeof d?.dh_rel !== 'undefined' ? d.dh_rel : this.state.dh_rel,
        })
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown)
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown)
    }

    setSelectedCollageId = (layout: CollageLayoutType) => {
        this.setState({ selectedCollageId: layout ? layout.id : null })

        const firstIndex = layout && layout.images ? parseInt(Object.keys(layout.images)[0]) : null
        if (firstIndex) {
            this.setSelectedImageId(firstIndex)
        }

        const target = document.getElementById('collage-layout-selected')
        if (target) {
            target.focus()
            target.scrollIntoView()
        }
    }

    renderAutocompleteIcon = (name: string) => {
        return <span style={{ position: 'absolute', top: '10px', right: 0 }} onClick={(e) => this.handleShowAutocomplete(name)}>
            <Icon type={'ellypsis-vertical-light'} color={iconDisabledColor} size={18} />
        </span>
    }
    renderAutocomplete = (name: string) => {
        const autocompleteValues = [
            { text: '1/6', value: 1 / 6 },
            { text: '1/5', value: 1 / 5 },
            { text: '1/4', value: 1 / 4 },
            { text: '1/3', value: 1 / 3 },
            { text: '1/2', value: 1 / 2 },
            { text: '2/3', value: 2 / 3 },
            { text: '1', value: 1 },
        ]

        const rendered = autocompleteValues.map(item => {
            return <MenuItem
                key={`${item.value}-${item.text}`}
                className={'muk-autocomplete__item'}
                onClick={() => this.handleClickItem(item.value, name)}>{item.text}</MenuItem>
        })

        return <CustomAutocomplete>{rendered}</CustomAutocomplete>
    }

    saveSelectedCollageLayout = (saveAsNew: boolean = false, shouldClose: boolean = true) => {
        const { isSaving } = this.state
        const { selectedCollageId } = this.state

        if (!isSaving) {
            const currentCollage: CollageLayoutType = this.findCollageById(selectedCollageId)
            this.setState({ isSaving: true })

            this.handleSaveCollageLayout(currentCollage, saveAsNew, shouldClose)
        }
    }

    findCollageById = (selectedCollageId: ID) => {
        const { collageLayoutsForm } = this.props
        const selectedCollage = find(collageLayoutsForm, (collageLayout) => {
            return `${collageLayout.id}` === `${selectedCollageId}`
        })
        return selectedCollage
    }

    findImageById = (selectedImageId: ID): CollageLayoutImageType => {
        const selectedCollage = this.findCollageById(this.state.selectedCollageId)
        const images = selectedCollage ? selectedCollage.images : []
        return find(images, (i) => {
            return `${i.id}` === `${selectedImageId}`
        })
    }

    handleKeyDown = (e) => {
        const { selectedImageId, selectedCollageId } = this.state

        if (e.target.tagName && e.target.tagName === 'INPUT') {
            return;
        }

        const selectedCollage = this.findCollageById(selectedCollageId)

        if (!e.ctrlKey) {
            if (e.keyCode === DELETE_KEY && selectedImageId !== null) {  //delete
                e.preventDefault()
                this.deleteImage(selectedCollage.id, selectedImageId)
            } else if (e.keyCode === INSERT_KEY) {   //insert
                e.preventDefault()
                this.newImage(selectedCollage.id)
            } else if (e.keyCode === ESCAPE_KEY) {   //escape
                e.preventDefault()
                this.setState({ selectedImageId: null })
            }
        } else {    //ctrl
            switch (e.key) {
                case 'z':   //undo
                    e.preventDefault()
                    if (this.undoHistory) {
                        this.undoHistory()
                    }
                    break;
                case 'y':   //redo
                    e.preventDefault()
                    if (this.redoHistory) {
                        this.redoHistory()
                    }
                    break;
                case 's':   //save
                    e.preventDefault()
                    this.saveSelectedCollageLayout(false, false)
                    break;
                case 'c': //copy
                    e.preventDefault()
                    const selectedImage = this.findImageById(selectedImageId)
                    if (selectedImage) {
                        const copiedImage = {
                            ...selectedImage,
                            id: null,
                            x_rel: .5,
                            y_rel: .5,
                        }
                        this.setState({ copyImage: copiedImage })
                    }
                    break;
                case 'v': //paste
                    e.preventDefault()
                    if (this.state.copyImage) {
                        const newIndex = unique_id()

                        let updatedImages = JSON.parse(JSON.stringify(selectedCollage.images))  //clone instead!!!
                        updatedImages[newIndex] = {
                            ...this.state.copyImage,
                            id: newIndex
                        }

                        this.props.change('collageLayoutsForm', `${selectedCollage.id}.images`, updatedImages)
                        this.setState({ selectedImageId: newIndex })
                    }
                    break
            }
        }
    }

    newImage = (selectedCollageId: ID) => {
        const { collageLayoutsForm } = this.props

        const currentCollageLayout = selectedCollageId ? find(collageLayoutsForm, (collageLayout) => {
            return collageLayout.id === selectedCollageId
        }) : null

        if (currentCollageLayout) {
            const newIndex = unique_id()

            let changedLayoutImages = currentCollageLayout.images
            changedLayoutImages[newIndex] = {
                id: newIndex,
                x_rel: .5,
                y_rel: .5,
                padding_px: 3,
                width_rel: 1 / 3,
                height_rel: 1 / 3,
                level: 1,
            }

            this.props.change('collageLayoutsForm', `${currentCollageLayout.id}.images`, changedLayoutImages)

            this.handleSaveCollageLayout({
                ...currentCollageLayout,
                images: changedLayoutImages
            }, false, false)

            this.setSelectedImageId(null)
        }
    }

    handleSaveCollageLayout = (collageLayout: CollageLayoutType, saveAsNew: boolean, shouldClose: boolean) => {
        const {isAlt} = this.props
        saveCollageLayout(collageLayout, saveAsNew)
            .then((response: AxiosResponse<{
                layouts: CollageLayoutType[],
                currentLayout: CollageLayoutType
            }>) => {
                const newCollageLayoutsForm: CollageLayoutType[] = response.data.layouts
                const formName = getFormName(isAlt)

                this.props.initForm('collageLayoutsForm', newCollageLayoutsForm)
                this.pushHistory()

                this.setSelectedCollageId(response.data.currentLayout)

                const updatedTemplateForm = {
                    ...this.props.form,
                    collage_layout_id: response.data.currentLayout.id,
                    collage_layout: response.data.currentLayout,
                }

                this.props.initForm(formName, updatedTemplateForm)

                if (shouldClose) {
                    this.props.closeModal()
                }
            })
            .catch((error) => {
                console.error('collage layout error', error.response)
            })
            .finally(() => this.setState({ isSaving: false }))
    }


    deleteImage = (selectedCollageId: ID, selectedImageId: ID) => {
        if (selectedImageId && selectedCollageId) {
            const currentCollageLayout = this.props.collageLayoutsForm[selectedCollageId]
            const changedLayoutImages = omitBy(currentCollageLayout.images, (collageLayoutImage) => `${selectedImageId}` === `${collageLayoutImage.id}`)

            this.props.change('collageLayoutsForm', `${selectedCollageId}.images`, changedLayoutImages)
            this.setSelectedImageId(null)

            const updatedCollageLayout: CollageLayoutType = {
                ...currentCollageLayout,
                images: changedLayoutImages
            }

            this.handleSaveCollageLayout(updatedCollageLayout, false, false)
        }
    }

    renderPreviewClipMasks = (layoutWidth: number, layoutHeight: number, collageLayout: CollageLayoutType) => {
        const { form } = this.props
        const { selectedImageId, dx_rel, dy_rel, dh_rel, dw_rel } = this.state

        if (!form?.is_collage || !collageLayout || !collageLayout.images || collageLayout.images.length === 0) {
            return <React.Fragment />
        }

        return <React.Fragment>
            {Object.keys(collageLayout.images).map((i) => {
                const image: CollageLayoutImageType = collageLayout.images[i]
                const isSelected = `${image.id}` === `${selectedImageId}`

                const imageXrel = image.x_rel + (isSelected ? dx_rel : 0)
                const imageYrel = image.y_rel + (isSelected ? dy_rel : 0)

                const imageWrel = image.width_rel + (isSelected ? dw_rel : 0)
                const imageHrel = image.height_rel + (isSelected ? dh_rel : 0)

                const isBezier = image.shape === 'bezier'

                const clipPathId = `collage-clip-path-edit-${collageLayout.id}-${image.id}`

                const scaleX = collageLayout.rel_width * layoutWidth
                const scaleY = collageLayout.rel_height * layoutHeight

                const width = scaleX * imageWrel - 2 * image.padding_px
                const height = scaleY * imageHrel - 2 * image.padding_px

                let thisWidth = width
                let thisHeight = height

                if (image.shape === 'circle') {
                    const minSide = Math.min(thisWidth, thisHeight)
                    thisWidth = minSide
                    thisHeight = minSide
                }

                const points = image.points ? JSON.parse(image.points) : [] //bezier nebo polygon

                let scaledPoints = [...points]  //relative units to pixels
                scaledPoints.forEach((point, index) => {
                    points[index].x = scaleX * imageWrel * point.x
                    points[index].y = scaleY * imageWrel * point.y

                    if (isBezier) {
                        points[index].cx = scaleX * imageWrel * point.cx
                    }

                    if (isBezier) {
                        points[index].cy = scaleY * imageHrel * point.cy
                    }
                })

                const maskObject: ClipMaskObject = {
                    ...EmptyClipMaskObject,
                    width: thisWidth,
                    height: thisHeight,
                    /* angle: image.angle, */
                    padding: image.padding_px,
                    x: 0,
                    y: 0,
                    isFilled: true,
                    type: image.shape ? image.shape : 'rect',
                    points: scaledPoints,
                }

                return <clipPath key={clipPathId} id={clipPathId} transform={`translate(${width / 2}, ${height / 2})`}>
                    {renderClipMaskShape(maskObject, false)}
                </clipPath>
            })}

        </React.Fragment>
    }

    reorder = (list: ItemInterface[], selectedCollageImage: CollageLayoutImageType, selectedCollageImageForm: string) => {
        const points = this.getPoints(selectedCollageImage)

        const order = points.map((point, i) => { return i })
        const newOrder = list.map(item => { return item.id })

        if (order.join(',') !== newOrder.join(',')) {
            let updatedPoints = []
            list.forEach(item => {
                updatedPoints.push(points[item.id])
            })
            this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.points`, JSON.stringify(updatedPoints))
        }
    }

    getPoints = (selectedCollageImage: CollageLayoutImageType) => {
        return selectedCollageImage && selectedCollageImage.points && isJson(selectedCollageImage.points) ? JSON.parse(selectedCollageImage.points) : null
    }

    render() {
        const { collageLayoutsForm, form, randomProduct, guides } = this.props
        const {
            selectedCollageId,
            isLoading,
            selectedImageId,
            showAutocomplete,
            autocompleteFor,
            selectedSizeFormat,
            isRelativeUnits,
            dx_rel,
            dy_rel,
            dw_rel,
            dh_rel
        } = this.state

        if (!collageLayoutsForm || isLoading) {
            return <Div padding="20px" textAlign="center">
                <Spinner type="bubbles" />
            </Div>
        }

        const previewSizeOptions: Option[] = this.props.sizes && this.props.sizes.isLoaded && this.props.sizes.data ? this.props.sizes.data.filter((size: SizeItem) => {
            return (size.name !== null && size.id !== null)
        }).map((size: SizeItem) => {
            return {
                label: `${size.name} [${size.width}x${size.height}]`,
                value: `${size.id}`
            }
        }) : null

        const selectedCollage = find(collageLayoutsForm, (collageLayout) => {
            return collageLayout.id === selectedCollageId
        })

        const selectedCollageImage: CollageLayoutImageType = selectedImageId && collageLayoutsForm[selectedCollageId]?.images[selectedImageId] ? collageLayoutsForm[selectedCollageId]?.images[selectedImageId] : null
        const selectedCollageImageForm: string = `${selectedCollageId}.images.${selectedImageId}`

        const imageShapeOptions: Option[] = CollageImageShapes.map((s: ClipMaskObjectType) => {
            return {
                label: trans(`${s}`),
                value: `${s}`,
            }
        })

        const points: PathPoint[] = this.getPoints(selectedCollageImage)
        const shapeType: ClipMaskObjectType = selectedCollageImage?.shape

        const list = points ? points.map((p, i) => ({ id: i, selected: false })) : null

        const iconSize = 20

        const templateSize = getTemplateSize(form)

        return (
            <StyledLayouts>
                <StyledGrid valign="bottom" style={{ marginBottom: '10px', height: 'calc(100vh - 100px)' }}>
                    <GridCell className="left-column max-height" style={{ border: '1px solid #eee', padding: '10px' }}>
                        <Grid className="toolsbar">
                            <Button
                                color="nocolor"
                                size="tiny"
                                title={trans(guides.isShowGrid ? 'toggle_snap_to_grid' : 'toggle_snap_to_element')}
                                icon={<Icon type={'magnet'} size={iconSize} color={!guides.isSnapOn ? iconDisabledColor : Theme.blue} />}
                                onClick={() => {
                                    this.props.setGuides({
                                        ...guides,
                                        isSnapOn: !guides.isSnapOn,
                                        isShowGuides: !guides.isSnapOn
                                    })
                                }}
                                className="shadow-box"
                            />
                            <Button
                                color="nocolor"
                                size="tiny"
                                title={trans('show_grid')}
                                style={{ background: !guides.isShowGrid ? '#fff' : `${Theme.blue} !important`, paddingTop: '4px' }}
                                icon={<IconGrid size={iconSize} color={!guides.isShowGrid ? Theme.blue : '#fff'} gridStepMode={guides.gridStepMode} />}
                                onClick={() => {
                                    const nextGridStepMode = (guides.gridStepMode + 1) % GRID_MODES_COUNT
                                    this.props.setGuides({
                                        ...guides,
                                        isShowGrid: nextGridStepMode > 0,
                                        gridStep: getGridStepSize(templateSize.width, templateSize.height, nextGridStepMode),
                                        gridStepMode: nextGridStepMode,
                                    })
                                }}
                                className="shadow-box"
                            />
                            <Button
                                color="nocolor"
                                size="tiny"
                                title={trans('history_undo')}
                                disabled={this.state.history.index === null || this.state.history.buffer.length === 1}
                                icon={<Icon type={'undo-light'} size={iconSize} color={Theme.blue} />}
                                onClick={() => this.undoHistory()}
                                className="shadow-box"
                            />
                             <Button
                                color="nocolor"
                                size="tiny"
                                title={trans('history_redo')}
                                disabled={this.state.history.index === null || typeof this.state.history.buffer[this.nextIndex(this.state.history.index)] === 'undefined'}
                                icon={<Icon type={'redo-light'} size={iconSize} color={Theme.blue} />}
                                onClick={() => this.redoHistory()}
                                className="shadow-box"
                            />
                            <GridCell col={'span 2'}>
                                <span className="shadow-box" style={{paddingTop: '3px', paddingBottom: '7px'}}>
                                <Button
                                        color="nocolor"
                                        size="tiny"
                                        title={trans('save')}
                                        icon={<Icon type={'save-light'} size={iconSize} color={Theme.blue} />}
                                        onClick={() => this.saveSelectedCollageLayout(false, false)}
                                        actions={[
                                            { children: <strong>{trans('save_as_new_collage')}</strong>, onClick: (e) => { this.saveSelectedCollageLayout(true) } },
                                        ]}
                                    />
                                </span>
                            </GridCell>
                        </Grid>

                        <TextInput
                            label={trans('layout_name')}
                            name={`collageLayoutsForm.${selectedCollageId}.name`}
                            style={{ width: '100%' }}
                        />

                        <Grid cols={'repeat(2, 1fr)'} gap={'20px'} style={{ padding: '10px', background: '#fff' }}>
                            {previewSizeOptions &&
                                <GridCell className={'selected-image-form'} col={'1/-1'}>
                                    <FieldLabel>{trans('preview_for_format')}</FieldLabel>
                                    <Select
                                        options={previewSizeOptions}
                                        value={selectedSizeFormat?.id}
                                        onChange={(sizeId) => this.handleChangePreviewSize(sizeId)}
                                    />
                                </GridCell>
                            }

                            {selectedCollageImage &&
                                <React.Fragment>
                                    <GridCell className={'selected-image-form'} col={'1/-1'}>
                                        <FieldLabel>{trans('background_color')}</FieldLabel>
                                        <TransparentColor
                                            name={`collageLayoutsForm.${selectedCollageImageForm}.bg_color_hex`}
                                            value={selectedCollageImage.bg_color_hex}
                                            changeValue={(color) => this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.bg_color_hex`, color)}
                                            notRequired={true}
                                        />
                                    </GridCell>
                                    <GridCell className={'selected-image-form'} col={'1/-1'}>
                                        <FieldLabel>{trans('collage_image_shape')}</FieldLabel>
                                        <Select
                                            options={imageShapeOptions}
                                            value={selectedCollageImage.shape || 'rectangle'}
                                            onChange={(value) => {
                                                if (selectedCollageImage.shape !== value) {

                                                    if (['polygon', 'bezier'].includes(value)) {
                                                        let initPoints: CoordsType[] | PathPoint[] = []
                                                        switch (value) {
                                                            case 'polygon':
                                                                initPoints.push({ x: -.4, y: -.1 })
                                                                initPoints.push({ x: .4, y: -.5 })
                                                                initPoints.push({ x: .4, y: .4 })
                                                                initPoints.push({ x: -.4, y: .4 })
                                                                break;
                                                            case 'bezier':
                                                                initPoints.push({ x: -.4, y: -.4, cx: -.3, cy: -.3 })
                                                                initPoints.push({ x: .4, y: -.4, cx: .3, cy: -.3 })
                                                                initPoints.push({ x: .4, y: .4, cx: .3, cy: .3 })
                                                                initPoints.push({ x: -.4, y: .4, cx: -.3, cy: .3 })
                                                                initPoints.push({ x: -.3, y: 0, cx: -.3, cy: .2 })
                                                                break;
                                                        }
                                                        this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.points`, JSON.stringify(initPoints))

                                                    } else {
                                                        this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.points`, null)
                                                    }
                                                    this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.shape`, value)
                                                }
                                            }}
                                        />
                                    </GridCell>

                                    <GridCell className={'selected-image-form'} col={'1/-1'}>
                                        <Range
                                            label={trans('scale')}
                                            name={`collageLayoutsForm.${selectedCollageImageForm}.scale`}
                                            defaultValue={1}
                                            min={0.1}
                                            max={10}
                                            step={.1}
                                            onClear={() => this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.scale`, 1)}
                                        />
                                    </GridCell>

                                    <GridCell className={'selected-image-form'} col={'1/-1'}>
                                        <Range
                                            label={trans('alpha')}
                                            name={`collageLayoutsForm.${selectedCollageImageForm}.alpha`}
                                            defaultValue={null}
                                            min={0}
                                            max={1}
                                            step={.1}
                                            onClear={() => this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.alpha`, null)}
                                        />
                                    </GridCell>
                                    <GridCell className={'selected-image-form'} col={'1/-1'}>
                                        <Range
                                            label={trans('angle')}
                                            name={`collageLayoutsForm.${selectedCollageImageForm}.angle`}
                                            defaultValue={0}
                                            min={-180}
                                            max={180}
                                            step={10}
                                            onClear={() => this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.angle`, null)}
                                        />
                                    </GridCell>
                                    <GridCell className={'selected-image-form'} col={'1/-1'}>
                                        <Range
                                            label={trans('padding_px')}
                                            name={`collageLayoutsForm.${selectedCollageImageForm}.padding_px`}
                                            defaultValue={0}
                                            min={0}
                                            max={Math.min(selectedSizeFormat.width, selectedSizeFormat.height)}
                                            step={10}
                                            onClear={() => this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.padding_px`, 0)}
                                        />
                                    </GridCell>

                                    <GridCell col={'1/-1'}><FieldLabel>{trans('layout_pos')} [{isRelativeUnits ? 'rel' : 'px'}]</FieldLabel></GridCell>

                                    <GridCell className={'rel'}>
                                        <TextInput
                                            value={this.displayValue(selectedCollageImage.x_rel, 'x')}
                                            onChange={(value) => this.handleChangeValue(value, 'x_rel')}
                                        />
                                        <Range
                                            key={`x_rel_${isRelativeUnits}`}
                                            /* name={`collageLayoutsForm.${selectedCollageImageForm}.x_rel`} */
                                            value={this.displayValue(selectedCollageImage.x_rel, 'x')}
                                            min={0}
                                            max={isRelativeUnits ? 1 : selectedSizeFormat.width}
                                            step={isRelativeUnits ? .05 : 10}
                                            onChange={(value) => this.handleChangeValue(value, 'x_rel')}
                                            onClick={(e) => this.handleClickOnTextInput(e, 'x_rel')}
                                            hideInput={true}
                                        />

                                        {this.renderAutocompleteIcon('x_rel')}
                                        {showAutocomplete && autocompleteFor === 'x_rel' &&
                                            this.renderAutocomplete('x_rel')
                                        }
                                    </GridCell>
                                    <GridCell className={'rel'}>
                                        <TextInput
                                            value={this.displayValue(selectedCollageImage.y_rel, 'y')}
                                            onChange={(value) => this.handleChangeValue(value, 'y_rel')}
                                        />
                                        <Range
                                            key={`y_rel_${isRelativeUnits}`}
                                            value={this.displayValue(selectedCollageImage.y_rel, 'y')}
                                            min={0}
                                            max={isRelativeUnits ? 1 : selectedSizeFormat.height}
                                            step={isRelativeUnits ? .05 : 10}
                                            onChange={(value) => this.handleChangeValue(value, 'y_rel')}
                                            onClick={(e) => this.handleClickOnTextInput(e, 'y_rel')}
                                            hideInput={true}
                                        />

                                        {this.renderAutocompleteIcon('y_rel')}
                                        {showAutocomplete && autocompleteFor === 'y_rel' &&
                                            this.renderAutocomplete('y_rel')
                                        }
                                    </GridCell>

                                    <GridCell col={'1/-1'}><FieldLabel>{trans('image_offset')} [{isRelativeUnits ? 'rel' : 'px'}]</FieldLabel></GridCell>

                                    <GridCell className={'rel'}>
                                        <TextInput
                                            value={this.displayValue(selectedCollageImage.x_offset, 'x')}
                                            onChange={(value) => this.handleChangeValue(value, 'x_offset')}
                                        />
                                        <Range
                                            key={`x_offset_${isRelativeUnits}`}
                                            value={this.displayValue(selectedCollageImage.x_offset, 'x')}
                                            min={isRelativeUnits ? -1 : -selectedSizeFormat.width}
                                            max={isRelativeUnits ? 1 : selectedSizeFormat.width}
                                            step={isRelativeUnits ? .05 : 10}
                                            onChange={(value) => this.handleChangeValue(value, 'x_offset')}
                                            onClick={(e) => this.handleClickOnTextInput(e, 'x_offset')}
                                            hideInput={true}
                                        />
                                        {this.renderAutocompleteIcon('x_offset')}
                                        {showAutocomplete && autocompleteFor === 'x_offset' &&
                                            this.renderAutocomplete('x_offset')
                                        }
                                    </GridCell>
                                    <GridCell className={'rel'}>
                                        <TextInput
                                            value={this.displayValue(selectedCollageImage.y_offset, 'y')}
                                            onChange={(value) => this.handleChangeValue(value, 'y_offset')}
                                        />
                                        <Range
                                            key={`y_offset_${isRelativeUnits}`}
                                            value={this.displayValue(selectedCollageImage.y_offset, 'y')}
                                            min={isRelativeUnits ? -1 : -selectedSizeFormat.height}
                                            max={isRelativeUnits ? 1 : selectedSizeFormat.height}
                                            step={isRelativeUnits ? .05 : 10}
                                            onChange={(value) => this.handleChangeValue(value, 'y_offset')}
                                            onClick={(e) => this.handleClickOnTextInput(e, 'y_offset')}
                                            hideInput={true}
                                        />
                                        {this.renderAutocompleteIcon('y_offset')}
                                        {showAutocomplete && autocompleteFor === 'y_offset' &&
                                            this.renderAutocomplete('y_offset')
                                        }
                                    </GridCell>

                                    <GridCell col={'1/-1'}>
                                        <FieldLabel>{trans('layout_size')} [{isRelativeUnits ? 'rel' : 'px'}]</FieldLabel>
                                    </GridCell>

                                    <GridCell className={'rel'}>
                                        <TextInput
                                            value={this.displayValue(selectedCollageImage.width_rel, 'x')}
                                            onChange={(value) => this.handleChangeValue(value, 'width_rel')}
                                        />
                                        <Range
                                            key={`width_${isRelativeUnits}`}
                                            value={this.displayValue(selectedCollageImage.width_rel, 'x')}
                                            min={0}
                                            max={isRelativeUnits ? 1 : selectedSizeFormat.width}
                                            step={isRelativeUnits ? .05 : 10}
                                            onChange={(value) => this.handleChangeValue(value, 'width_rel')}
                                            onClick={(e) => this.handleClickOnTextInput(e, 'width_rel')}
                                            hideInput={true}
                                        />
                                        {this.renderAutocompleteIcon('width_rel')}
                                        {showAutocomplete && autocompleteFor === 'width_rel' &&
                                            this.renderAutocomplete('width_rel')
                                        }
                                    </GridCell>
                                    <GridCell className={'rel'}>
                                        <TextInput
                                            value={this.displayValue(selectedCollageImage.height_rel, 'y')}
                                            onChange={(value) => this.handleChangeValue(value, 'height_rel')}
                                        />
                                        <Range
                                            key={`height_${isRelativeUnits}`}
                                            value={this.displayValue(selectedCollageImage.height_rel, 'y')}
                                            min={0}
                                            max={isRelativeUnits ? 1 : selectedSizeFormat.height}
                                            step={isRelativeUnits ? .05 : 10}
                                            onChange={(value) => this.handleChangeValue(value, 'height_rel')}
                                            onClick={(e) => this.handleClickOnTextInput(e, 'height_rel')}
                                            hideInput={true}
                                        />
                                        {this.renderAutocompleteIcon('height_rel')}
                                        {showAutocomplete && autocompleteFor === 'height_rel' &&
                                            this.renderAutocomplete('height_rel')
                                        }
                                    </GridCell>

                                    <GridCell col={'1/-1'} className={'hide-buttons'}>
                                        <InputGroup
                                            orientation="horizontal"
                                            singleChoice={true}
                                            value={isRelativeUnits}
                                            label={trans('units')}
                                            onChange={(value) => this.setState({ isRelativeUnits: value })}
                                            items={[
                                                { value: 1, label: 'rel' },
                                                { value: 0, label: 'px' },
                                            ]}
                                        />
                                    </GridCell>


                                    {points &&
                                        <GridCell className={'selected-image-form'} col={'1/-1'}>
                                            <div style={{ margin: '10px 0' }}>{trans('points_coordinates')}</div>
                                            <table>
                                                <tr>
                                                    <th />
                                                    <th className={'center'}>x</th>
                                                    <th className={'center'}>y</th>
                                                    {shapeType === 'bezier' && <React.Fragment>
                                                        <th className={'center'}>cx</th>
                                                        <th className={'center'}>cy</th>
                                                    </React.Fragment>}
                                                    <th />
                                                </tr>

                                                <ReactSortable list={list} setList={(list) => this.reorder(list, selectedCollageImage, selectedCollageImageForm)} handle=".drag-handle" tag="tbody">
                                                    {points.map((point, key) => {
                                                        return <tr key={`point_row${key}`}>
                                                            <td className="drag-handle"><Icon type={'arrows-v'} color={Theme.blue} />{key}</td>
                                                            <td>
                                                                <StyledTextInput
                                                                    type={'number'}
                                                                    value={point.x}
                                                                    onChange={(val) => {
                                                                        let updatedPoints = [...points]
                                                                        const point = updatedPoints[key]
                                                                        updatedPoints[key] = { ...point, x: val }
                                                                        this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.points`, JSON.stringify(updatedPoints))
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <StyledTextInput
                                                                    type={'number'}
                                                                    value={point.y}
                                                                    onChange={(val) => {
                                                                        let updatedPoints = [...points]
                                                                        const point = updatedPoints[key]
                                                                        updatedPoints[key] = { ...point, y: val }
                                                                        this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.points`, JSON.stringify(updatedPoints))
                                                                    }}
                                                                />
                                                            </td>
                                                            {shapeType === 'bezier' &&
                                                                <React.Fragment>
                                                                    <td>
                                                                        <StyledTextInput
                                                                            type={'number'}
                                                                            value={point.cx}
                                                                            onChange={(val) => {
                                                                                let updatedPoints = [...points]
                                                                                const point = updatedPoints[key]
                                                                                updatedPoints[key] = { ...point, cx: val }
                                                                                this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.points`, JSON.stringify(updatedPoints))
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <StyledTextInput
                                                                            type={'number'}
                                                                            value={point.cy}
                                                                            onChange={(val) => {
                                                                                let updatedPoints = [...points]
                                                                                const point = updatedPoints[key]
                                                                                updatedPoints[key] = { ...point, cy: val }
                                                                                this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.points`, JSON.stringify(updatedPoints))
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </React.Fragment>
                                                            }
                                                            <td>
                                                                <span
                                                                    title={trans('delete')}
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        let updatedPoints = [...points]
                                                                        updatedPoints.splice(key, 1)
                                                                        this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.points`, JSON.stringify(updatedPoints))
                                                                    }}>
                                                                    <Icon type={'close'} color={Theme.red} />
                                                                </span>
                                                                <span
                                                                    title={trans('add_point')}
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        let updatedPoints = [...points]
                                                                        const prevPoint = points.length > 1 ? points[(key - 1) % (points.length - 1)] : point
                                                                        const newPoint: CoordsType = {
                                                                            x: Math.round((point.x + prevPoint.x) / 2),
                                                                            y: Math.round((point.y + prevPoint.y) / 2),
                                                                        }
                                                                        updatedPoints.splice(key, 0, newPoint)
                                                                        this.props.change('collageLayoutsForm', `${selectedCollageImageForm}.points`, JSON.stringify(updatedPoints))
                                                                    }}>
                                                                    <Icon type={'plus'} color={Theme.blue} />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    })}
                                                </ReactSortable>
                                            </table>
                                        </GridCell>
                                    }
                                </React.Fragment>
                            }
                        </Grid>
                    </GridCell>

                    <GridCell className="middle-column" style={{ alignSelf: 'center' }}>
                        {selectedCollageId &&
                            <svg
                                id="collage-layout-selected"
                                xmlns="http://www.w3.org/2000/svg"
                                width={selectedSizeFormat.width}
                                height={selectedSizeFormat.height}
                                viewBox={`0 0 ${selectedSizeFormat.width} ${selectedSizeFormat.height}`}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: 'calc(100vh - 110px)',
                                    width: 'auto',
                                    height: 'auto',
                                    overflow: 'auto',
                                }}>

                                <defs>
                                    {this.renderPreviewClipMasks(selectedSizeFormat.width, selectedSizeFormat.height, selectedCollage)}
                                </defs>

                                <rect id="collage-layout-selected-box" fill={'#ffffff'} x={0} y={0} width={selectedSizeFormat.width} height={selectedSizeFormat.height} style={{ pointerEvents: 'none' }} />
                                <rect stroke={'#3a3a3a'} x={0} y={0} width={selectedSizeFormat.width} height={selectedSizeFormat.height} fill={'transparent'} style={{ pointerEvents: 'auto' }} onClick={() => this.setSelectedImageId(null)} />

                                <AlternativeImageSvg
                                    draggable={true}
                                    pushHistory={this.pushHistory}
                                    layoutWidth={selectedSizeFormat.width}
                                    layoutHeight={selectedSizeFormat.height}
                                    selectedCollage={selectedCollage}
                                    randomProduct={randomProduct}
                                    selectedImageId={selectedImageId}
                                    selectedImageAngle={selectedCollageImage?.angle}
                                    dx_rel={dx_rel}
                                    dy_rel={dy_rel}
                                    dw_rel={dw_rel}
                                    dh_rel={dh_rel}
                                    setSelectedImageId={this.setSelectedImageId}
                                    setSelectedCollageId={this.setSelectedCollageId}
                                    setD={this.setD}
                                    isShadow={false}
                                    isAnim={false}
                                    previewMode={true}
                                />
                            </svg>
                        }
                    </GridCell>

                    <GridCell className="right-column">
                        <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                            <Button
                                type={'void'}
                                secondary={true}
                                color={'nocolor'}
                                style={{
                                    fontSize: '20px',
                                    fontWeight: 'normal',
                                }}
                                onClick={() => {
                                    this.saveSelectedCollageLayout()
                                    this.props.closeModal()
                                }}>{trans('done')}</Button>
                        </div>

                        {selectedCollageId &&
                            <CollageLayoutsImages
                                selectedCollageId={selectedCollageId}
                                selectedImageId={selectedImageId}
                                setSelectedImageId={this.setSelectedImageId}
                                setSelectedCollageId={this.setSelectedCollageId}
                                deleteImage={this.deleteImage}
                                newImage={this.newImage}
                            />
                        }
                    </GridCell>
                </StyledGrid>
            </StyledLayouts>
        )
    }
}

const StyledLayouts = css('div')({
    paddingBottom: '20px',
    ' .alt-image-layout': {
        stroke: '#fff',
    },
    ' #collage-layouts-wrapper': {
        height: 'calc(100vh - 120px)',
    },
    backgroundColor: "transparent",
    borderRadius: "5px",
    textAlign: "center",
    cursor: "pointer",
    fontSize: "14px",
    color: "#333",
    pointerEvents: 'auto',
    ' rect.alt-image-layout + image:hover': {
        fill: 'transparent',
    },
    ' .resizable-handle': {
        fill: '#565dff',
        zIndex: 99999,
        pointerEvents: 'auto',
    },
    ' .params': {
        textAlign: 'left',
    },
    ' .muk-form-label': {
        textAlign: 'left',
    },
    ' .buttons': {
        textAlign: 'left',
        ' .muk-button': {
            margin: '5px',
        },
    },
    ' .muk-textinput': {
        marginBottom: 0,
    },
    ' .left': {
        textAlign: 'left',
    },
    ' .react-select-item-options': {
        textAlign: 'left',
    },
    ' .muk-form-group': {
        marginBottom: '0px',
    }
})

const StyledGrid = css(Grid)({
    gridTemplateColumns: '300px auto 300px',
    gridGap: '5px',
    overflowY: 'auto',
    '@media screen and (max-width: 1024px)': {
        gridTemplateColumns: 'auto auto',
    },
    '@media screen and (max-width: 800px)': {
        gridTemplateColumns: 'auto',
    },
    ' .action-button': {
        padding: '10px',
    },
    ' .rel': {
        position: 'relative',
    },
    ' .max-height': {
        maxHeight: 'calc(100vh - 40px)',
        overflow: 'auto',
    },
    ' .toolsbar': {
        gridTemplateColumns: 'repeat(auto-fit, 38px)',
        gridGap: '2px',
        marginBottom: '20px',
    }
})

const MenuItem = css("div")({
    padding: "5px 20px",
    fontSize: "0.9em",
    cursor: "pointer",
    borderRadius: 0,
    borderBottom: "1px solid #eee",
}, (props: any) => {
    if (props.disabled) {
        return {
            background: "#eee",
            color: "#888",
        }
    }
    if (props.selected) {
        return {
            background: Theme.blue,
            color: "white",
        }
    } else
        if (props.highlighted) {
            return {
                background: "#f4f4f4",
            }
        } else {
            return {
                background: "transparent",
            }
        }
})

const CustomAutocomplete = css("div")({
    overflowY: 'auto',
    maxHeight: '200px',
    padding: 0,
    margin: 0,
    position: 'relative',
    top: '-50px',
    background: '#ffffff',
    borderRadius: '4px',
    border: '1px solid #cccccc',
    borderTop: '0px',
})

const StyledTextInput = css(TextInput)({
    fontSize: '10px',
    ' input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
        ' -webkit-appearance': 'none',
        ' -webkit-box-sizing': 'border-box',
        ' -moz-box-sizing': 'border-box',
        ' box-sizing': 'border-box',
        margin: 0,
        padding: 0,
    },
    ' input[type=number]': {
        ' -moz-appearance': 'textfield',
    },
})

function mapStateToProps(state) {
    return {
        collageLayoutsForm: selectFormValues(state, 'collageLayoutsForm'),
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
        randomProduct: state.randomProduct,
        sizes: state.sizes,
        guides: state.guides,
    }
}

export default connect(mapStateToProps, {
    initForm,
    change,
    setGuides,
})(CollageLayouts)
